import { Routes, Route } from "react-router-dom";
import { TaxHistory } from "./list";

export default function TaxHistoryRoutes() {
  return (
    <Routes>
      <Route path="/" element={<TaxHistory />} />
    </Routes>
  );
}
